export interface CoursePurchaseInputs {
  isPurchasable: boolean;
  price: number | null;
  ownedByViewer: boolean;
  isAdmin: boolean;
}

export type CoursePurchaseCta =
  | { kind: 'buy'; price: number }
  | { kind: 'hidden' };

export function deriveCoursePurchaseState(
  i: CoursePurchaseInputs,
): CoursePurchaseCta {
  const shouldShowBuy =
    i.isPurchasable &&
    i.price != null &&
    i.price > 0 &&
    !i.ownedByViewer &&
    !i.isAdmin;

  if (shouldShowBuy) {
    return { kind: 'buy', price: i.price };
  }

  return { kind: 'hidden' };
}
